var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass:
            "d-flex flex-column flex-sm-row justify-sm-space-between gap-2",
          attrs: { cols: "12" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column flex-sm-row align-sm-center gap-2",
            },
            [
              _c("h1", { staticClass: "title primary--text mr-4" }, [
                _vm._v(" เลือกสินค้าที่ต้องการพิมพ์บาร์โค้ด "),
              ]),
              _c("BarcodeFilter", {
                attrs: { value: _vm.filter },
                on: {
                  onFilter: function ($event) {
                    return _vm.handleFilter($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column flex-sm-row align-sm-center gap-2",
            },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.searchText,
                  placeholder: "ค้นหาสินค้า",
                  "append-icon": "mdi-magnify",
                  outlined: "",
                  "hide-details": "",
                  dense: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setSearchTextDebounce($event)
                  },
                },
              }),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c("snt-export", {
                    attrs: {
                      headers: _vm.strHeaders,
                      callback: _vm.getExport,
                      extract: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ attrs, submitting, disabled, on }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "mb-sm-0 ml-sm-3",
                                    attrs: {
                                      color: "primary",
                                      height: "40",
                                      loading: submitting,
                                      disabled: disabled,
                                      ripple: false,
                                      rounded: "",
                                      elevation: "0",
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_vm._v(" Export File ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("div", { staticClass: "mr-3" }),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  _vm._b(
                                    { attrs: { color: "primary" } },
                                    "v-icon",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v(" mdi-information-outline ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("p", [_vm._v("โปรแกรมที่แนะนำ")]),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(" 1. GoLabel (สำหรับปรินท์เตอร์ GoDex) "),
                      ]),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(" 2. Label4J (สำหรับเครื่องพิมพ์ A4 Sticker) "),
                      ]),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(" 3. Bartender (สำหรับเครื่องพิมพ์ Thermal) "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.productList
        ? _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("ProductTableBarcode", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.productList.nodes,
                  "total-pages": _vm.productList.pagesCount,
                  loading: _vm.$apollo.queries.productList.loading,
                  page: _vm.page,
                  "per-page": _vm.perPage,
                  printable: "",
                },
                on: {
                  onPageChange: function ($event) {
                    return _vm.handlePageChange($event)
                  },
                },
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        { staticClass: "d-flex justify-end", attrs: { cols: "12" } },
        [
          _c("BarcodeSetting", {
            attrs: {
              items: _vm.itemsForPrint,
              disabled: _vm.$_.isEmpty(_vm.itemsForPrint),
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }